import appInfo from "@common/appInfo";
import { type DateTimePickerProps, type ValueType } from "@common/controls/Inputs/DateTimePicker/component";
import moment, { type Moment } from "moment-timezone";

const FORMATS = {
  DATE_TIME: "YYYY-MM-DD[T]HH:mm:00[Z]",
  DATE: "YYYY-MM-DD[T]00:00:00[Z]"
};

export const toInputValue = (value: ValueType, isUtcTime?: boolean): Moment | null => {
  if (!value) return null;
  if (moment.isMoment(value)) return value;

  let date = isUtcTime ? moment.utc(value || "") : moment(value || "");

  //If date is not valid, try and parse SQL date format
  if (!date.isValid()) {
    date = isUtcTime ? moment.utc(value || "", "MMM DD YYYY  h:mmA") : moment(value, "MMM DD YYYY  h:mmA");
  }

  if (date.isValid()) {
    return isUtcTime ? date : date.tz(appInfo.business.timeZoneIana);
  } else {
    return isUtcTime ? moment.utc() : moment.tz(appInfo.business.timeZoneIana);
  }
};

export const toOutputValue = (props: DateTimePickerProps, value: Moment | null): ValueType => {
  if (value === null) return null;
  if (moment.isMoment(props.value)) return moment.isMoment(value) ? value : moment(value);
  if (props.value instanceof Date) return value;

  const format = props.format
    ? props.format
    : props.timeOnly || (props.hasTime ?? true)
    ? FORMATS.DATE_TIME
    : FORMATS.DATE;
  return moment.utc(value).format(format);
};
